/** IndiaFees brand — PNG logo + favicon from public/ */

export function LogoMark({ size = 36, className = "" }) {
  return (
    <img
      src="/favicon.png"
      alt="IndiaFees"
      width={size}
      height={size}
      className={`if-logo-mark-img ${className}`.trim()}
    />
  );
}

export function LogoWordmark({ className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="IndiaFees"
      className={`if-logo-img ${className}`.trim()}
      decoding="async"
      fetchPriority="high"
    />
  );
}
